import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AppService } from 'src/app/appservice.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-new-customer',
  templateUrl: './new-customer.component.html',
  styleUrls: ['./new-customer.component.css']
})
export class NewCustomerComponent implements OnInit {

  customerForm: FormGroup;
  isAddress = false;
  isSubmitting = false;

  constructor(public dialogRef: MatDialogRef<NewCustomerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public service: AppService) {
    const gstpattern = '^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[A-Z]{1}[0-9A-Z]{1}$';
    const panpattern = '^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$';
    const mobilepattern = '^(?:(?:\\+|0{0,2})91(\\s*[\\ -]\\s*)?|[0]?)?[56789]\\d{9}|(\\d[ -]?){10}\\d$';
    this.customerForm = new FormGroup({
      id: new FormControl(0),
      name: new FormControl(data.name),
      phone: new FormControl(),
      mobile: new FormControl('', [Validators.pattern(mobilepattern)]),
      address: new FormControl(),
      landmark: new FormControl(),
      pincode: new FormControl(),
      city: new FormControl(),
      state: new FormControl(service.df_state),
      country: new FormControl('India'),
      gstin: new FormControl('', [Validators.pattern(gstpattern)]),
      pan: new FormControl('', [Validators.pattern(panpattern)]),
      description: new FormControl()
    });


    this.customerForm.controls.address.valueChanges.subscribe(x => this.addressskip());
    if (data.id != null && data.id > 0) {
      this.service.getRequest('api/customers/' + data.id).subscribe(x => {
        this.customerForm.controls.id.patchValue(x.id);
        this.customerForm.controls.name.patchValue(x.name);
        this.customerForm.controls.mobile.patchValue(x.mobile);
        this.customerForm.controls.phone.patchValue(x.phone);
        this.customerForm.controls.address.patchValue(x.address);
        this.customerForm.controls.pincode.patchValue(x.pincode);
        this.customerForm.controls.landmark.patchValue(x.landmark);
        this.customerForm.controls.city.patchValue(x.city);
        this.customerForm.controls.state.patchValue(x.state);
        this.customerForm.controls.country.patchValue(x.country);
        this.customerForm.controls.pan.patchValue(x.pan);
        this.customerForm.controls.gstin.patchValue(x.gstin);
        this.customerForm.controls.description.patchValue(x.description);
      });
    }
  }

  ngOnInit() {
  }

  onNoClick(): void {
    this.customerForm.reset();
    this.dialogRef.close();
  }

  addressskip() {
    if (this.customerForm.controls.address.value == null || this.customerForm.controls.address.value === '') {
      // this.productnameField.nativeElement.focus();
      this.isAddress = false;
    } else {
      this.isAddress = true;
    }
  }
  handleEnterKeyPress(event) {
    const tagName = event.target.tagName.toLowerCase();
    if (tagName !== 'textarea' && tagName !== 'button') {
      return false;
    }
  }
  onSubmit() {
    try {
      this.isSubmitting = true;
      if (this.customerForm.valid) {
        // this.customerForm.value.itemunitId = this.customerForm.value.unit.id;
        this.service.getRequestData('api/customers', this.customerForm.value).subscribe((data) => {
          console.log(data);
          if (data.Success) {
            this.data.name = this.customerForm.controls.name.value;
            this.dialogRef.close(data.data);
          } else {
            if (data.Error === 'Customer.AlreadyExists') {
              this.service.sendMessage('Customer.AlreadyExists');
            } else {
              this.service.sendMessage('Customer.CreateFailedRetry');
            }
          }
        },
          (err) => {
            console.log('Item creation failed : ' + err);
            this.service.sendMessage('Oops');
          });
      } else {
        this.service.sendMessage('Customer.FillAllDetails');
      }
    } catch (ex) {
      console.log(ex);
      this.service.sendMessage('Oops');
    } finally {
      this.isSubmitting = false;
    }
  }


  keytab2(target) {
    // var element = document.querySelector("input[formControlName='" + target + "']") as HTMLInputElement;
    // if (element != null)
    //   {
    //     element.focus();
    //   }
  }
}

export interface DialogData {
  id: number;
  name: string;
}
